import {
  UserNotificationChannel,
  UserNotificationSettings,
} from "@axl-dev/school-sdk";
import { notification, Typography } from "antd";
import { useCallback, useEffect, useState } from "react";

import { useLoc, useSdk } from "@app/shared/lib/hooks";
import { LoadingOverlay } from "@app/shared/ui/LoadingOverlay";

import { NotificationChannelTable } from "./components/ChannelTable/NotificationChannelTable";
import { NotificationSettingsForm } from "./components/SettingsForm/NotificationSettingsForm";

export const NotificationsTab: React.FC = () => {
  const loc = useLoc();

  const [settings, setSettings] = useState<UserNotificationSettings | null>(
    null,
  );
  const sdk = useSdk();
  useEffect(() => {
    (async () => {
      const result = await sdk.api.notification.settings.fetch();
      const notificationSettings = result.body.settings;
      if (notificationSettings == null) {
        notification.error({
          message: loc.word("Error occured"),
          duration: 2,
        });

        return;
      }

      setSettings(notificationSettings);
    })();
  }, [loc, sdk.api.notification.settings]);

  const updateChannelSettings = useCallback(
    (updatedChannel: UserNotificationChannel) => {
      setSettings((prev) =>
        prev
          ? new UserNotificationSettings({
              ...prev,
              channels: prev?.channels.map((channel) =>
                channel.notificationType === updatedChannel.notificationType
                  ? new UserNotificationChannel(updatedChannel)
                  : channel,
              ),
            })
          : prev,
      );
    },
    [],
  );

  if (settings == null) return <LoadingOverlay />;

  return (
    <>
      <Typography.Title level={3}>
        {loc.word("Notif.settingsLabel")}
      </Typography.Title>
      <NotificationSettingsForm
        settings={settings}
        onChange={(updatedSettings) => setSettings(updatedSettings)}
      />

      <Typography.Title level={3} className="mt-30 mb-10">
        {loc.word("Notif.typesLabel")}
      </Typography.Title>
      <NotificationChannelTable
        readonlyEmail={!settings.useEmail}
        readonlyTg={!settings.useTg}
        channels={settings.channels}
        updateChannelSettings={updateChannelSettings}
      />
    </>
  );
};
